
export const xs_local_storage_keys = [
    'ACCEPTANCE_PEND_LS',
    'BETSLIP_LS',
    'BETSLIP_PSV_LS',
    'current_voucher',
    'favorite_markets',
    'favorite_tournaments',
    'isCartPinned',
    'land-from-banner',
    'last_physical_rest_self_voucher_read',
    'LAST_TICKET_PURCHASED',
    'lastLoggedUserAccountIds',
    'operator_logged_parameters',
    'PURCHASE_STATUS',
    'pvrUserToken',
    'x_als_last_fetched',
    'x_fav_mtchs',
    'xs_add_n_bet_params',
    'xs_aggregate',
    'xs_bets_expanded',
    'xs_configuration',
    'xs_custom_aliases_enabled',
    'xs_labels',
    'xs_live_sort_type',
    'xs_localstorage_version',
    'xs_macrogruppi',
    'xs_prematch_sort_type',
    'xs_print_aggs',
    'xs_print_aggs_signature',
    'XS_PRINT_SETTINGS',
    'xs_reservation_print_type',
    'XS_RETRY_TRANSACTION_ID',
    'xs_scraped_data',
    'xs_show_tutorial',
    'xs_signature_aggregate',
    'xs_signature_configuration',
    'xs_signature_labels',
    'xs_signature_macrogruppi',
    'xs_tmcv',
    'xs_user_settings',
    'xsh_cf_ok',
    'xsh_vip_system',
    'xsh_vip_system_enabled',
    'XSP_RESERVATIONS',
    'XSP_SCROLLABLE_CART'
];

export function xs_clearLocalStorage() {
    try {
        xs_local_storage_keys.forEach(key => localStorage.removeItem(key));
    } catch(err) {
        console.error(err);
    }
}

export function xs_setVipSystemData(vipSystemData){
	try{
		console.debug("impostato vip system: " + vipSystemData);
		let value = vipSystemData;
		if(typeof vipSystemData === 'object'){
			value = JSON.stringify(value);
		}
		localStorage.setItem('xsh_vip_system', value);	
	}
	catch(e){
	 console.error(e);
	}

}

export function xs_getVipSystemData(asObject){
	const vipSystemData = localStorage.getItem("xsh_vip_system");
	if(asObject && vipSystemData){
		return JSON.parse(vipSystemData);
	}
	return vipSystemData;
}

export function xs_clearVipSystemData(callerFunctionName){
	const vip = xs_getVipSystemData();
	if(vip){
		console.debug("Logout del vip system : " + xs_getVipSystemData() + " da funzione " + callerFunctionName);	
	}
	localStorage.removeItem("xsh_vip_system")
}

export function xs_setVipSystemEnabled(enabled) {
    localStorage.setItem('xsh_vip_system_enabled', enabled);	
}

export function xs_getVipSystemEnabled() {
    return localStorage.getItem('xsh_vip_system_enabled');	
}

export function xs_clearVipSystemEnabled(){
	localStorage.removeItem("xsh_vip_system_enabled")
}

export function clearStorageKeepingCriticalData() {
    const backupMap = {};
    const operatorData = localStorage.getItem("operator_logged_parameters");
    const voucherData = localStorage.getItem("current_voucher");
    const reservationData = localStorage.getItem("XSP_RESERVATIONS");
    const socketPort = localStorage.getItem("socketPort");
    if (operatorData) {
        backupMap['operator_logged_parameters'] = operatorData;
    }
    if (voucherData) {
        backupMap['current_voucher'] = voucherData;
    }
    if (reservationData) {
        backupMap['XSP_RESERVATIONS'] = reservationData;
    }
    if (socketPort) {
        backupMap['socketPort'] = socketPort;
    }
    
    xs_clearLocalStorage();
    for (let k in backupMap) {
        localStorage.setItem(k, backupMap[k]);
    }
}
